import React from "react";
import styles from "./TaskButton.module.css";
import checkIcon from "/check-icon.svg";
import waitIcon from "../../../assets/Task_new_icons/task-waiting.svg";
import arrowIcon from "/arrow.svg";
import { useModalStore } from "../../Store/ModalStore";
import { Task } from "../../Pages/Tasks_new/types";
import { getReferrers, ReferrerCallback } from "../../Services/Requests";

export type TaskButtonVariant =
  | "NOT_STARTED"
  | "IN_PROGRESS"
  | "WAITING"
  | "DONE"
  | "CLAIMED"
  | "CLAIMED_WITH_LINK";

export interface TaskButtonProps {
  variant: TaskButtonVariant;
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  task: Task;
}

export const TaskButton: React.FC<TaskButtonProps> = ({
  variant,
  text,
  onClick,
  disabled = false,
  task,
}) => {
  const setOpen = useModalStore((state) => state.setOpen);
  const setCurrentTask = useModalStore((state) => state.setCurrentTask);

  const handleClick = () => {
    console.log("TaskButton clicked for task:", task);
    if (variant === "CLAIMED_WITH_LINK" && task.link) {
      window.Telegram.WebApp.openTelegramLink(task.link);
      return;
    }
    // Проверяем специальное задание "Пригласи друга"
    if (task.title === "Пригласи друга" && task.status !== "DONE") {
      try {
        const callback: ReferrerCallback = (
          _mineRef,
          userData,
          _shareStories
        ) => {
          if (userData?.link) {
            window.Telegram.WebApp.openTelegramLink(
              `https://t.me/share/url?url=${userData.link}`
            );
          }
        };
        getReferrers(callback);
        return;
      } catch (error) {
        console.error("Error sharing referral link:", error);
      }
    }

    // Для партнерских заданий с ссылкой
    if (task.type === "partners" && task.link) {
      setOpen(true);
      setCurrentTask(task);
      if (onClick) onClick();
      return;
    }

    // Для ежедневных заданий со статусом DONE
    if (task.type === "quest-daily" && task.status === "DONE") {
      setCurrentTask(task);
      setOpen(true);
      if (onClick) {
        console.log("Calling onClick for daily task:", task.id);
        onClick();
      }
      return;
    }

    // Для всех остальных заданий открываем модальное окно
    setCurrentTask(task);
    setOpen(true);
    if (onClick) onClick();
  };

  return (
    <button
      className={`${styles.button} ${styles[variant]}`}
      onClick={handleClick}
      disabled={disabled || (["CLAIMED", 'WAITING'].includes(variant) && !task.link)}
    >

      {variant !== 'WAITING' && variant !== "CLAIMED" && variant !== "CLAIMED_WITH_LINK" && <>{text}</>}

      {variant === "WAITING" && (
        <>
          {text}
          <img src={waitIcon} alt="waiting" className={styles.waitIcon} />
        </>
      )}

      {
        variant === "CLAIMED" && (
          <>
            {text}
            <img src={checkIcon} alt="check" className={styles.checkIcon} />
          </>
        )
      }

      {
        variant === "CLAIMED_WITH_LINK" && (
          <img src={arrowIcon} alt="arrow" className={styles.arrowIcon} />
        )
      }
    </button >
  );
};
